import type { Page } from '@ps/web-core-store';
import { TrackingCategory, TrackingContext } from '@ps/web-shared-analytics';
import React from 'react';

import CMSReferences from '../CMSReference/CMSReferences';

import PageBody from './PageBody/PageBody';

interface Props {
  content: Page['content'];
  template?: Page['template'];
  theme?: Page['theme'];
}

const CMSPage: React.FC<Props> = ({ content, template, theme }) => {
  const twoColumns = template === '2 Column';
  const darkTheme = theme === 'Dark';
  const [{ seo, top, side, main }] = content;

  return (
    <TrackingContext.Provider
      value={{
        category: TrackingCategory.Stars,
        widget: { widgetName: 'CMS Page Widget', widgetId: 'cms-page-widget' }
      }}
    >
      <CMSReferences references={seo} />
      <CMSReferences references={top} />
      <PageBody side={side} main={main} twoColumns={twoColumns} darkTheme={darkTheme} />
    </TrackingContext.Provider>
  );
};

export default CMSPage;
